module.exports = __webpack_public_path__ + "img/A低通锐化1.06aba78d.png";